import Vue from 'vue'
import { Route } from 'vue-router'
import store from '../store/store'
import RouteName from '@/utils/RouteName'
import { RawLocation } from 'vue-router/types/router'
import Swal from 'sweetalert2'
import { jwtTokenName } from '@/utils/auth'

export function redirectToEventLoginIfNotConnected(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
) {
    // @ts-ignore
    const userState = store.state.user
    // Fallback to the session storage in case of store is not filled yet
    const jwtToken = userState.token || window.currentJwt || window.sessionStorage.getItem(jwtTokenName) || null

    if (jwtToken) {
        return next()
    }

    console.warn('Not connected, redirect by Vue router to the login page')
    Swal.fire({
        icon: 'warning',
        title: 'You are not connected',
        text: 'You need to login before accessing this page',
    })
    const eventId = to.params.eventId

    if (to.name === 'event-backstage') {
        return next({
            name: RouteName.EVENT_LIVE_MANUAL_LOGIN,
            params: {
                eventId,
            },
            query: {
                redirect: 'backstage',
            },
        })
    } else {
        return next({
            name: RouteName.EVENT_LIVE_MANUAL_LOGIN,
            params: {
                eventId,
            },
        })
    }
}

export function redirectToEventPayment(to: Route) {
    const url = new URL(`${process.env.VUE_APP_SPA2_BASE_URL}/event/${to.params.eventId}/payment`)

    for (const [key, value] of Object.entries(to.query)) {
        if (typeof value === 'string') {
            url.searchParams.set(key, value)
        }
    }
    window.location.href = url.toString()
}
